import React from 'react';
import PropTypes from 'prop-types';
import './FormButton.scss';

export default function FormButton(props) {
  const { children, disabled } = props;
  return (
    // eslint-disable-next-line react/button-has-type
    <button type="button" {...props} disabled={disabled} className="custom-button">
      {children}
    </button>
  );
}

FormButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

FormButton.defaultProps = {
  disabled: false,
};
